import React, { useState } from "react";
import "./sidebar.scss";
import PrimarySidebar from "./primarySidebar/PrimarySidebar.js";
import SecondarySidebar from "./secondarySidebar/SecondarySidebar.js";

const NewSidebar = (props) => {
  const { logout, menu, merchant } = props;
  const is_main_merchant = merchant?.is_easebuzz_merchant && !merchant?.user?.email;
  return (
    <div className="eb_sidebar_wrapper">

      {is_main_merchant && <PrimarySidebar merchant_data={merchant} logout={logout} menu={menu} />}
      <SecondarySidebar is_main_merchant={is_main_merchant} menu={menu} />

    </div>
  );
};

export default NewSidebar;
